/* eslint-disable @typescript-eslint/no-explicit-any */
import { BeltColorEnum } from '@shared/enum/belt-color.enum';
import { IProgram, IVideo } from 'src/shared/interface/model.interface';

export class ProgramDto implements IProgram {
  public id?: number;
  public label?: string;
  public comment?: string;
  public programOrder?: number;
  public isKyu?: boolean;
  public isDan?: boolean;
  public gradeOrder?: number;
  public gradeLevel?: number;
  public beltCode?: BeltColorEnum;

  public videos: IVideo[] = [];

  constructor(init?: Partial<any>) {
    (Object as any).assign(this, init);
  }
}
